import { useContext } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UILink from 'UIComponents/link/UILink';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import { P, LinkSpace } from './TwoFactorStyledComponents';
import { TwoFactorRecoveryContext } from '../../contexts/twoFactorRecovery';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TwoFactorRecoveryChoice = () => {
  const {
    goToAdmin,
    goToSupport
  } = useContext(TwoFactorRecoveryContext);
  return /*#__PURE__*/_jsxs(UIDialogBody, {
    children: [/*#__PURE__*/_jsx(P, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "reAuth.recovery.form.description"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "2fa-get-help-from-admin-button",
      onClick: goToAdmin,
      type: "button",
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reAuth.recovery.form.recoveryAdminButton"
      })
    }), /*#__PURE__*/_jsx(LinkSpace, {
      children: /*#__PURE__*/_jsx(UILink, {
        "data-test-id": "2fa-get-help-from-support-button",
        onClick: goToSupport,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reAuth.recovery.form.recoverySupportButton"
        })
      })
    })]
  });
};